import { connect } from 'react-redux';
import LoadingButton from './LoadingButton';

export default connect(({ settings }) => ({
  ...settings,
}))(LoadingButton);
